import { useEffect, useState } from 'react';
import { Stack, Title, Text, Button, Box } from '@mantine/core';
import { getStandToken } from '../../wheel-api/stand';
import { useNavigate } from 'react-router-dom';
import { WHEEL_SLUG } from '../../utils/cvdl';
import { api } from '../../wheel-api/client';
import { WheelCanvas } from './WheelCanvas';

export function Attractor() {
  const navigate = useNavigate();
  const [prizes, setPrizes] = useState([]);

  // Los premios reales, para que la ruleta en reposo muestre lo que se puede
  // ganar. Si falla, WheelCanvas cae en 12 gajos alternados sin etiqueta.
  useEffect(() => {
    let vivo = true;
    api.getWheelPublic(WHEEL_SLUG)
      .then(w => { if (vivo) setPrizes(w.prizes || []); })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);

  return (
    <Stack align="center" justify="center" style={{ flex: 1 }} gap="md" px="xl">
      <Box style={{ width: 'min(46vh, 78vw)' }}>
        <WheelCanvas prizes={prizes} loop />
      </Box>

      <Stack align="center" gap={2}>
        <Title
          order={1} ta="center" c="forvet.7"
          style={{ fontSize: 'clamp(24px, 4.2vh, 46px)', lineHeight: 1.1, letterSpacing: '-.01em' }}
        >
          ¿QUÉ QUERÉS APRENDER A RESOLVER?
        </Title>
        <Text size="xl" c="forvet.6" ta="center" fw={500}>
          Girá la ruleta. Todos se llevan algo.
        </Text>
      </Stack>

      <Button
        className="cta-latido"
        h={78} w={400} radius="xl"
        onClick={() => navigate('/kiosk/checkin')}
        style={{ boxShadow: '0 4px 16px rgba(23,63,110,.18)' }}
      >
        QUIERO GIRAR
      </Button>

      {/* Solo aparece mientras la tablet no está armada, o sea al montarla.
          Una vez armada desaparece y nadie vuelve a ver un PIN. */}
      {!getStandToken() && (
        <Button variant="subtle" size="xs" c="dimmed"
                onClick={() => navigate('/kiosk/armar')}>
          Armar tablet
        </Button>
      )}
    </Stack>
  );
}
